import {
  getDependents,
  getDependentById,
  updateDependentById
} from '../../network';
import {
  FETCH_DEPENDENTS_WITH_PARAMS,
  FETCH_DEPENDENT_BY_ID,
  PATCH_DEPENDENT_BY_ID
} from './types';

const store = {};
const getDefaultState = () => ({});

store.state = getDefaultState();

store.getters = {};

store.mutations = {};

store.actions = {
  async [FETCH_DEPENDENTS_WITH_PARAMS](_, query) {
    const response = await getDependents(query);
    return response.data;
  },
  async [FETCH_DEPENDENT_BY_ID](_, dependentId) {
    const response = await getDependentById(dependentId);
    return response.data;
  },
  async [PATCH_DEPENDENT_BY_ID](_, { dependentId, payload }) {
    const response = await updateDependentById(dependentId, payload);
    return response.data;
  }
};

export default store;
